// extracted by mini-css-extract-plugin
module.exports = {"input":"input__3B_I9","buttons":"buttons__2fCeK","error":"error__3Lbay"};